/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetMarketMakerSelfStatus200,
  GetMarketMakerSelfStatus401,
  GetMarketMakerSelfStatus404,
} from '../types/GetMarketMakerSelf'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getMarketMakerSelf } from '../clients/getMarketMakerSelf'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getMarketMakerSelfQueryKey = () => [{ url: '/v1/market-makers/self' }] as const

type GetMarketMakerSelfQueryKey = ReturnType<typeof getMarketMakerSelfQueryKey>

export function getMarketMakerSelfQueryOptions(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getMarketMakerSelfQueryKey()
  return queryOptions<
    GetMarketMakerSelfStatus200,
    ResponseErrorConfig<GetMarketMakerSelfStatus401 | GetMarketMakerSelfStatus404>,
    GetMarketMakerSelfStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getMarketMakerSelf({
        ...config,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description Any authenticated user. Returns the market maker configuration whose user_id is the caller, or 404 when the caller is not a market maker.
 * @summary Get the caller's market maker
 * {@link /v1/market-makers/self}
 */
export function useGetMarketMakerSelf<
  TData = GetMarketMakerSelfStatus200,
  TQueryData = GetMarketMakerSelfStatus200,
  TQueryKey extends QueryKey = GetMarketMakerSelfQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetMarketMakerSelfStatus200,
        ResponseErrorConfig<GetMarketMakerSelfStatus401 | GetMarketMakerSelfStatus404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getMarketMakerSelfQueryKey()

  const queryResult = useQuery(
    {
      ...getMarketMakerSelfQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetMarketMakerSelfStatus401 | GetMarketMakerSelfStatus404>
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
